import React from 'react';

import DrawerM, { DrawerProps as DrawerPropsM } from '@mui/material/Drawer';

export interface DrawerProps extends DrawerPropsM {
  /** The content of the component. */
  children: React.ReactNode;
  /** Side from which the drawer will appear. */
  anchor: DrawerPropsM['anchor'];
  /**
   * Override or extend the styles applied to the component.

   */
  classes?: DrawerPropsM['classes'];
  /** The elevation of the drawer. 16 by default */
  elevation?: DrawerPropsM['elevation'];
  /** If true, the backdrop is not rendered. */
  hideBackdrop?: DrawerPropsM['hideBackdrop'];
  /** Callback fired when the component requests to be closed. */
  onClose?: DrawerPropsM['onClose'];
  /** If true, the component is shown. */
  open: DrawerPropsM['open'];
  /** The variant to use. */
  variant?: DrawerPropsM['variant'];
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.

   */
  sx?: DrawerPropsM['sx'];
}

/**
 * @deprecated Use Drawer from @mint-lib/tw-components instead
 */
const Drawer = (props: DrawerProps) => (
  <DrawerM
    ModalProps={{
      BackdropProps: {
        sx: { backgroundColor: (theme) => theme.palette.ui.overlay },
      },
    }}
    PaperProps={{
      sx: {
        boxShadow: 'none',
        padding: '1.5rem',
        borderLeft: (theme) =>
          props.hideBackdrop && props.anchor === 'right'
            ? `1px solid ${theme.palette.border.primary}`
            : 'none',
      },
    }}
    {...props}
  >
    {props.children}
  </DrawerM>
);

export default Drawer;
